import { render, staticRenderFns } from "./PopupTip.vue?vue&type=template&id=088db70e"
import script from "./PopupTip.vue?vue&type=script&lang=js"
export * from "./PopupTip.vue?vue&type=script&lang=js"
import style0 from "./PopupTip.vue?vue&type=style&index=0&id=088db70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports